<div class="w-full">
    <div class="flex justify-content-center align-items-center" style="width: 100%; height: 30vh;" *ngIf="!loaded">
        <p-progressSpinner ariaLabel="loading" />
    </div>

    <div *ngIf="loaded">
        <form [formGroup]="formPartner">
            <div class="flex flex-column gap-4">
                <div class="flex flex-row gap-4">
                    <div class="flex flex-column gap-2 w-full">
                        <label for="name">Nome</label>
                        <input id="name" type="text" pInputText formControlName="name" />
                    </div>
                    <div class="flex flex-column gap-2 w-full">
                        <label for="cpfCnpj">CPF/CNPJ</label>
                        <input id="cpfCnpj" type="text" pInputText formControlName="cpfCnpj" />
                    </div>
                </div>

                <div class="flex flex-row gap-4">
                    <div class="flex flex-column gap-2 w-full">
                        <label for="email">E-mail</label>
                        <input id="email" type="text" pInputText formControlName="email" />
                    </div>
                    <div class="flex flex-column gap-2 w-full">
                        <label for="phone">Telefone</label>
                        <input id="phone" type="text" pInputText formControlName="phone" />
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="flex flex-column gap-2 w-full">
                        <label for="from">Origem</label>
                        <input id="from" type="text" pInputText formControlName="from" />
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="flex flex-column gap-2 w-full">
                        <label for="address">Endereço</label>
                        <input id="address" type="text" pInputText formControlName="address" />
                    </div>
                </div>

            </div>

        </form>

        <div class="flex justify-content-end" style="margin-top: 2rem;">
            <p-button icon="pi pi-plus" label="Adicionar" class="createButton" [disabled]="!formPartner.valid"
                (click)="AddPartner()"></p-button>
        </div>

    </div>
</div>